import { z } from 'zod';

// zod probes `new Function` when a z.object schema is created; Trusted Types
// blocks it and logs a violation. Must load before any module creates a schema.
z.config({ jitless: true });
